import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { getImageUrl } from "@/utils/imageUrl";

export function VideoCard({ post, className = "" }) {
  const { slug, title, excerpt, featured_image_url, video_url } = post;

  const placeholderImage = "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=800&q=80";

  // Extract YouTube thumbnail if video_url is YouTube
  const getThumbnail = () => {
    if (featured_image_url) return getImageUrl(featured_image_url);
    if (video_url?.includes("youtube.com") || video_url?.includes("youtu.be")) {
      const videoId = video_url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/)?.[1];
      if (videoId) return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }
    return placeholderImage;
  };

  return (
    <Link
      to={`/videos/${slug}`}
      className={`group relative aspect-video rounded-2xl overflow-hidden cursor-pointer block ${className}`}
      data-testid={`video-card-${slug}`}
    >
      <img
        src={getThumbnail()}
        alt={title}
        className="w-full h-full object-cover img-zoom"
      />
      <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors" />
      
      {/* Play Button */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-white/95 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
        <Play className="h-7 w-7 text-primary ml-1" fill="currentColor" />
      </div>

      {/* Title */}
      <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
        <h3 className="font-heading text-white font-semibold line-clamp-2">
          {title}
        </h3>
        {excerpt && (
          <p className="text-gray-300 text-sm mt-1 line-clamp-1">{excerpt}</p>
        )}
      </div>
    </Link>
  );
}

export function VideoCardSkeleton() {
  return (
    <div className="aspect-video rounded-2xl bg-gray-100 animate-pulse">
      <div className="h-full flex items-center justify-center">
        <div className="w-16 h-16 bg-gray-200 rounded-full" />
      </div>
    </div>
  );
}
